<template>
  <el-container class="stui-content" style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;">


      <el-col :span="18" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 80%;margin-top: 10px;">


        <el-row  class="tui-el" style="margin-bottom: 20px;">
          <el-col :span="4" style="text-align: center;">功能</el-col>
          <el-col :span="4" style="text-align: center;">lid</el-col>
          <el-col :span="4" style="text-align: center;">排序</el-col>
          <el-col :span="4" style="text-align: center;">初始时间</el-col>
          <el-col :span="4" style="text-align: center;">更新间隔</el-col>
          <el-col :span="4" style="text-align: center;">操作</el-col>
        </el-row>

        <el-row  class="tui-el" v-for="(item,index) in list" :key="index" >
          <el-col :span="4" style="text-align: center;line-height: 60px;" @click.native="change(item.name,item.lid)">{{item.name}}</el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;">{{item.lid}}</el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;">{{item.orders}}</el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;"><input type="text" v-model="list[index]['time']"/></el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;"><input type="text" v-model="list[index]['uptime']"/></el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;color: #0000FF;" @click.native="add(item.id,index)">保存</el-col>
        </el-row>
      </el-col>


    </el-row>

  <el-dialog
    title="修改"
    :visible.sync="centerDialogVisible"
    width="30%"
    center>
    <input type="text" class="searchT" v-model="addT"/>
    <input type="text" class="searchT" v-model="addP" style="margin-top: 10px;"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="centerDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doAdd()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>


</template>

<script>

  export default {
    data() {
       return {
        list: [],
        addT:'',
        lid:0,
        addP:0,
        centerDialogVisible:false,

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData()

    },

	methods:{

    change(name,lid){
      this.addT = name
      this.lid = lid
      this.centerDialogVisible = true
    },


    loadData(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          week:this.value,
          s_id:this.qipaoId
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTimeList'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },
    doAdd(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.lid,
          name:this.addT,
          order:this.addP,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTimeChange'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.centerDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            this.loadData()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    add(id,index){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          time:this.list[index]['time'],
          uptime:this.list[index]['uptime']
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTimeAdd'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            this.loadData()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .searchT{
  	width: 80%;
  	margin-left: 10%;
  	height: 30px;
  }
  .stui-content{
    margin-left: 10%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/main/stime.vue